// extracted by mini-css-extract-plugin
export default {"commentsSummary":"_0ee32ff8f73247f4","red":"_53da0ed938aeaab2","tooltip":"_06407fb88e93c511","redText":"e594f681ee969a1e","pointerCursor":"_44cd802ae80e203d"};